<template>
	<div class="checkItem">
		<span @click="checkedItem" class="item icon">
			<div class="colorCheck" :style="{'background':checked?color:'transparent'}"></div>
		</span>
		<span @click="checkedItem" class="item label">
			<slot></slot>
		</span>
	</div>
</template>

<script>
	export default {
		name: 'checkItem',
		props: {
			label: {
				type: [Number, String],
				default: 0
			},
			color: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				checked: false,
				currentValue: this.label,
			}
		},
		methods: {
			checkedItem() {
				this.checked = !this.checked
				if (this.checked) {
					this.$parent.currentValue.push(this.label)
				} else {
					this.$parent.currentValue.splice(this.$parent.currentValue.findIndex(item => item == this.label), 1)
				}
			}
		},
	}
</script>

<style scoped lang="scss">
	.checkItem {
		display: inline-block;
		vertical-align: middle;
		margin: 0px 10px;

		.item {
			display: inline-block;
			vertical-align: middle;
			cursor: pointer;
		}

		.icon {
			width: 20px;
			height: 20px;
			border: 1px solid black;
			border-radius: 5px;
			padding: 3px;
			.colorCheck{
				width: 100%;
				height: 100%;
			}
		}

		.label {
			margin-left: 5px;
			font-weight: 600;
			font-size: 16px;
			color: #333333;
		}

	}
</style>
